export default __webpack_public_path__ + "static/media/flag_cz.01f884ca.svg";